import * as React from 'react';
import {Field, formValueSelector, InjectedFormProps, reduxForm , submit } from 'redux-form';
import {IAuthState} from '../../../../services/auth/models';
import {IChannel, ICustomer, IProduct} from '../../../../data/api/models';
import {II18nMessages} from '../../../../services/branding/models';
import {IQuoteActions, IQuoteState} from '../../../../services/quote/models';
import {Button, Col, ControlLabel, Form, FormGroup, HelpBlock, Modal, Row} from 'react-bootstrap';
import NavigationBar from '../../components/NavigationBar';
import Login from '../../../CustomerArea/scenes/Login';
import {
  isEmail,
  isRequired,
} from '../../../../util/validators';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../redux/IStore';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import FieldFormControl from '../../../../components/FieldFormControl';
import {isUndefined} from 'util';
import FaCheck from 'react-icons/fa/check';
import FaInfoCircle = require('react-icons/lib/fa/info-circle');
import ContactUsModal from '../../components/ContactUsModal';

interface IDeclarationFormProps extends InjectedFormProps {
  dispatch: any;
  auth: IAuthState;
  startDate: string;
  product: IProduct;
  renewal: boolean;
  channel: IChannel;
  i18n: II18nMessages;
  quote: IQuoteState;
  renderDefinition(name: string): any;
  actions: {
    quote: IQuoteActions;
  };

  insured: ICustomer;
  email: string;
  emailConfirmation: string;
  declaration: string[];
  vehicleCount: number;
  declarationQuestion: string[];
  assumptionsQuestion: string[];
  assumptionsPass: boolean;
}

interface IDeclarationFormStates {
  showAssumptions: boolean;
  declines?: any;
  referrals?: any;
  errors?: any;
  showAssumptionsError: boolean;
  notFocused: boolean;
}

class DeclarationForm extends React.Component<IDeclarationFormProps, IDeclarationFormStates> {
  public state = {
    showAssumptions: false,
    declines: [],
    referrals: [],
    errors: [],
    showAssumptionsError: false,
    notFocused: false,
  };

  public componentWillMount() {
    const {dispatch, change, auth, renewal, quote} = this.props;
    dispatch(change('quotationTypes', 'Msamlin Direct'));

    if (auth.isAuthenticated) {
      dispatch(change('insured.email', auth.customer.email));
      dispatch(change('insured.emailConfirmation', auth.customer.email));
      dispatch(change('insured.title', auth.customer.title));
      dispatch(change('insured.firstName', auth.customer.firstName));
      dispatch(change('insured.lastName', auth.customer.lastName));
      dispatch(change('insured.dob', auth.customer.dob));
      dispatch(change('insured.companyName', auth.customer.companyName));
      dispatch(change('insured.metadata', auth.customer.metadata));
      dispatch(change('insured.address', auth.customer.address));
      dispatch(change('insured.phone1', auth.customer.phone1));
      dispatch(change('personalCustomerString', auth.customer.companyName ? 'false' : 'true'));
      dispatch(change('personalCustomer', auth.customer.companyName ? false : true));
    }

    if (renewal) {
      dispatch(change('assumptionsQuestion[0]', quote.application.declaration[5] === 'none' ? 'false' : 'true'));
      dispatch(change('assumptionsQuestion[1]', 'true'));
      dispatch(change('assumptionsQuestion[2]', 'true'));
      dispatch(change('assumptionsQuestion[3]', 'true'));
      dispatch(change('assumptionsQuestion[4]', 'true'));
      dispatch(change('assumptionsQuestion[5]', 'true'));
      dispatch(change('assumptionsQuestion[6]', 'true'));
      dispatch(change('assumptionsQuestion[7]', 'true'));
      dispatch(change('assumptionsQuestion[8]', 'true'));
      dispatch(change('assumptionsQuestion[9]', 'true'));
      if (quote.application.declaration[16] === 'false') {
        dispatch(change('assumptionsQuestion[10]', 'false'));
        dispatch(change('assumptionsQuestion[7]', ''));
        dispatch(change('assumptionsQuestion[8]', ''));
        dispatch(change('assumptionsQuestion[9]', ''));
      } else {
        dispatch(change('assumptionsQuestion[10]', 'true'));
      }
    }
  }

  public componentWillReceiveProps(nextProps) {
    const {dispatch, change, auth, actions} = this.props;

    if (auth.isAuthenticated !== nextProps.auth.isAuthenticated && nextProps.auth.isAuthenticated) {
      actions.quote.resetExistingCustomerCheck();
      dispatch(change('insured.id', nextProps.auth.customer.id));
      dispatch(change('insured.title', nextProps.auth.customer.title));
      dispatch(change('insured.firstName', nextProps.auth.customer.firstName));
      dispatch(change('insured.lastName', nextProps.auth.customer.lastName));
      dispatch(change('insured.dob', nextProps.auth.customer.dob));
      dispatch(change('insured.email', nextProps.auth.customer.email));
      dispatch(change('insured.emailConfirmation', nextProps.auth.customer.email));
      dispatch(change('insured.address', nextProps.auth.customer.address));
      dispatch(change('insured.metadata', nextProps.auth.customer.metadata));
      dispatch(change('insured.companyName', nextProps.auth.customer.companyName));
      dispatch(change('insured.phone1', nextProps.auth.customer.phone1));
      dispatch(change('personalCustomerString', nextProps.auth.customer.companyName ? 'false' : 'true'));
      dispatch(change('personalCustomer', nextProps.auth.customer.companyName ? false : true));
    }
  }

  private renderVehicleCounter() {
    const {dispatch} = this.props;

    return (
      <div className="sub-content-container">
        <div className="vehicle-row">
          <div className="vehicle">
            <img src={require('../../img/vehicle.svg')} alt="" />
            How many agricultural vehicles would you like insure:
          </div>
          <Field
            dispatch={dispatch}
            name="vehicleCount"
            type="number"
            component={FieldFormControl}
            min="0"
          />
        </div>
      </div>
    );
  }

  private openAssumptionsModal = () => {
    this.setState({
      showAssumptions: true,
    });
  }

  private closeAssumptionsModal = () => {
    this.setState({
      showAssumptions: false,
    });
  }

  private setAssumption = () => {
    this.closeAssumptionsModal();
    setTimeout(() => this.handleSubmit(), 400);
  }

  private renderAssumptions() {
    const { assumptionsPass, renderDefinition, channel, renewal } = this.props;
    const { showAssumptions, showAssumptionsError } = this.state;

    return (
      <Modal show={showAssumptions} onHide={this.closeAssumptionsModal}>
        <Modal.Header closeButton={true}>
          <Modal.Title>
            Assumptions
            <hr />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="model-fade assumptions">
            <p>To make things quicker we have made the following assumptions which we would ask you
              to confirm as being correct:</p>
            <FormGroup controlId="declaration.2">
              <ul>
                <Row>
                  <li className={!assumptionsPass && !renewal ? 'line2' : ''}>
                    <Col sm={8}>
                      You have previously held an Agricultural Motor Insurance policy
                    </Col>
                    <Col sm={4}>
                      <Row className="button-group-container">
                        <Col sm={6} className="button-group-btn-container">
                          <Field
                            name="assumptionsQuestion[0]"
                            type="radio"
                            value="false"
                            component={FieldFormControl}
                            onClick={this.validateAssumptions}
                          >
                            <div className={'button-group-btn'}>
                              No
                              <FaCheck/>
                            </div>
                          </Field>
                        </Col>
                        <Col sm={6} className="button-group-btn-container">
                          <Field
                            name="assumptionsQuestion[0]"
                            type="radio"
                            value="true"
                            component={FieldFormControl}
                            onClick={this.validateAssumptions}
                          >
                            <div className={'button-group-btn'}>
                              Yes
                              <FaCheck/>
                            </div>
                          </Field>
                        </Col>
                      </Row>
                    </Col>
                  </li>
                </Row>
                {this.props.assumptionsQuestion &&
                (this.props.assumptionsQuestion[0] === 'true' || this.props.assumptionsQuestion[0] === 'false') && (
                  <Row>
                    <li className={!assumptionsPass && !renewal ? 'line3' : ''}>
                      <Col sm={8}>
                        All vehicles are owned by you and remain in your care, custody and control
                      </Col>
                      <Col sm={4}>
                        <Row className="button-group-container">
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[1]"
                              type="radio"
                              value="false"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                No
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[1]"
                              type="radio"
                              value="true"
                              component={FieldFormControl}
                            >
                              <div className={'button-group-btn'}>
                                Yes
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                        </Row>
                      </Col>
                    </li>
                  </Row>
                )}
                {this.props.assumptionsQuestion && this.props.assumptionsQuestion[1] === 'true' && (
                  <Row>
                    <li className={!assumptionsPass && !renewal ? 'line4' : ''}>
                      <Col sm={8}>
                        All vehicles are kept overnight at your correspondence address
                      </Col>
                      <Col sm={4}>
                        <Row className="button-group-container">
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[2]"
                              type="radio"
                              value="false"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                No
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[2]"
                              type="radio"
                              value="true"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                Yes
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                        </Row>
                      </Col>
                    </li>
                  </Row>
                )}
                {this.props.assumptionsQuestion && this.props.assumptionsQuestion[2] === 'true' && (
                  <Row>
                    <li className={!assumptionsPass && !renewal ? 'line5' : ''}>
                      <Col sm={8}>
                        None of the vehicles are Harvesters
                      </Col>
                      <Col sm={4}>
                        <Row className="button-group-container">
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[3]"
                              type="radio"
                              value="false"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                No
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[3]"
                              type="radio"
                              value="true"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                Yes
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                        </Row>
                      </Col>
                    </li>
                  </Row>
                )}
                {this.props.assumptionsQuestion && this.props.assumptionsQuestion[3] === 'true' && (
                  <Row>
                    <li className={!assumptionsPass && !renewal ? 'line6' : ''}>
                      <Col sm={8}>
                        All drivers hold a valid driving licence (except where a fully trained driver over
                        the age of 15 years uses an agricultural vehicle in a place where no licence is required by law)
                      </Col>
                      <Col sm={4}>
                        <Row className="button-group-container">
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[4]"
                              type="radio"
                              value="false"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                No
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[4]"
                              type="radio"
                              value="true"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                Yes
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                        </Row>
                      </Col>
                    </li>
                  </Row>
                )}
                {this.props.assumptionsQuestion && this.props.assumptionsQuestion[4] === 'true' && (
                  <Row>
                    <li className={!assumptionsPass && !renewal ? 'line7' : ''}>
                      <Col sm={8}>
                        No drivers have been involved in a motor accident or made a motor insurance claim
                        during the past 3 years
                      </Col>
                      <Col sm={4}>
                        <Row className="button-group-container">
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[5]"
                              type="radio"
                              value="false"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                No
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[5]"
                              type="radio"
                              value="true"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                Yes
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                        </Row>
                      </Col>
                    </li>
                  </Row>
                )}
                {this.props.assumptionsQuestion && this.props.assumptionsQuestion[5] === 'true' && (
                  <Row>
                    <li className={!assumptionsPass && !renewal ? 'line8' : ''}>
                      <Col sm={8}>
                        {renderDefinition('b2c_assumptions_convictions')}
                        No drivers have any unspent convictions according to the Rehabilitation of
                        Offenders Act, nor have any prosecutions pending for any major motoring convictions or more than
                        2 minor motoring convictions
                      </Col>
                      <Col sm={4}>
                        <Row className="button-group-container">
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[6]"
                              type="radio"
                              value="false"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                No
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[6]"
                              type="radio"
                              value="true"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                Yes
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                        </Row>
                      </Col>
                    </li>
                  </Row>
                )}
                {this.props.assumptionsQuestion && this.props.assumptionsQuestion[6] === 'true' && (
                  <Row>
                    <li className={!assumptionsPass && !renewal ? 'line9' : ''}>
                      <Col sm={8}>
                        Will this vehicle / these vehicles be used in connection with your trade or occupation?
                      </Col>
                      <Col sm={4}>
                        <Row className="button-group-container">
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[10]"
                              type="radio"
                              value="false"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                No
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[10]"
                              type="radio"
                              value="true"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                Yes
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                        </Row>
                      </Col>
                    </li>
                  </Row>
                )}
                {this.props.assumptionsQuestion && this.props.assumptionsQuestion[10] === 'true' && (
                  <Row>
                    <li className={!assumptionsPass && !renewal ? 'line9' : ''}>
                      <Col sm={8}>
                        {renderDefinition('b2c_assumptions_business_use')}
                        Any business use is of an agricultural nature
                      </Col>
                      <Col sm={4}>
                        <Row className="button-group-container">
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[7]"
                              type="radio"
                              value="false"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                No
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[7]"
                              type="radio"
                              value="true"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                Yes
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                        </Row>
                      </Col>
                    </li>
                  </Row>
                )}
                {this.props.assumptionsQuestion && this.props.assumptionsQuestion[7] === 'true' && (
                  <Row>
                    <li className={!assumptionsPass && !renewal ? 'line10' : ''}>
                      <Col sm={8}>
                        The revenue derived from Agricultural/Forestry contracting contributes less than
                        10% of the proposers total annual turnover
                      </Col>
                      <Col sm={4}>
                        <Row className="button-group-container">
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[8]"
                              type="radio"
                              value="false"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                No
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[8]"
                              type="radio"
                              value="true"
                              component={FieldFormControl}
                              onClick={this.validateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                Yes
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                        </Row>
                      </Col>
                    </li>
                  </Row>
                )}
                {this.props.assumptionsQuestion && this.props.assumptionsQuestion[8] === 'true' && (
                  <Row>
                    <li className={!assumptionsPass && !renewal ? 'line11' : ''}>
                      <Col sm={8}>
                        {renderDefinition('b2c_assumptions_carriage_use')}
                        Vehicles are not used for the carriage of passengers or goods for hire and reward
                      </Col>
                      <Col sm={4}>
                        <Row className="button-group-container">
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[9]"
                              type="radio"
                              value="false"
                              component={FieldFormControl}
                              onClick={this.overallValidateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                No
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                          <Col sm={6} className="button-group-btn-container">
                            <Field
                              name="assumptionsQuestion[9]"
                              type="radio"
                              value="true"
                              component={FieldFormControl}
                              onClick={this.overallValidateAssumptions}
                            >
                              <div className={'button-group-btn'}>
                                Yes
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                        </Row>
                      </Col>
                    </li>
                  </Row>
                )}
              </ul>
            </FormGroup>
            {showAssumptionsError && (
              <div className="alert alert-danger">
                <p>
                  Thank you for your enquiry. Please note that due to your selection(s), we are unable to continue
                  with your quotation online - to enable us to assist you, please <ContactUsModal
                  channel={channel} text="contact us" linkClass="inherit-color" /> to speak with one of our
                  specialist advisors.
                </p>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="pull-left btn-secondary notification-btn-size"
            onClick={this.closeAssumptionsModal}
          >
            Close
          </Button>
          {this.props.declaration && this.props.declaration[2] === 'true' && (
            <Button
              className="continue-btn btn-primary notification-btn-size"
              onClick={this.setAssumption}
            >
              Continue
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }

  private areEmailsSame() {
    const { insured } = this.props;

    if (isUndefined(insured)) {
      return true;
    }

    return (! insured.email || ! insured.emailConfirmation)
      || insured.email === insured.emailConfirmation;
  }

  private validateDeclaration() {
    const {declaration} = this.props;
    for (const key in declaration) {
      if (declaration[key] === 'false' && 16 !== parseInt(key, 10)) {
        return false;
      }
    }
    return true;
  }

  private declarationAgreed = () => {
    const {declarationQuestion, dispatch, change } = this.props;

    if (isUndefined(declarationQuestion)) {
      return false;
    }
    for (const key in declarationQuestion) {
      if ((declarationQuestion[key] === '' || declarationQuestion[key] === 'false') && parseInt(key, 10) < 5) {
        dispatch(change('declaration[1]', 'false'));
        return false;
      }
    }
    dispatch(change('declaration[1]', 'true'));
    return true;
  }

  private validateAssumptions = (event) => {
    const { dispatch, change } = this.props;

    if (isUndefined(event.target.value)) {
      return false;
    }

    // false for question 10 should skip remaining assumptions
    if (event.target.name === 'assumptionsQuestion[10]') {
      if (event.target.value === 'false') {
        dispatch(change('declarationTradeVehicle', false));
        dispatch(change('declaration[16]', 'false'));
        this.setState({
          showAssumptionsError: false,
        });
        dispatch(change('declaration[2]', 'true'));
        this.setAssumption();
        return true;
      } else if (event.target.value === 'true') {
        dispatch(change('declarationTradeVehicle', true));
        dispatch(change('declaration[16]', 'true'));
      }
    }

    // false for question 0 should set declararation to no prior insurance
    if (event.target.name === 'assumptionsQuestion[0]') {
      if (event.target.value === 'false') {
        dispatch(change('declaration[5]', 'none'));
      } else if (event.target.value === 'true') {
        dispatch(change('declaration[5]', ''));
      }
    }

    if (event.target.value === 'false' && event.target.name !== 'assumptionsQuestion[0]') {
      dispatch(change('declaration[2]', 'false'));
      this.setState({
        showAssumptionsError: true,
      });
    } else if (event.target.value === 'true' || event.target.name === 'assumptionsQuestion[0]') {
      this.setState({
        showAssumptionsError: false,
      });
    }
  }

  private overallValidateAssumptions = (event) => {
    const { assumptionsQuestion, dispatch, change } = this.props;

    if (isUndefined(assumptionsQuestion)) {
      return false;
    }
    if (event.target.value === 'false' && event.target.name !== 'assumptionsQuestion[0]') {
      dispatch(change('declaration[2]', 'false'));
      this.setState({
        showAssumptionsError: true,
      });
    } else if (event.target.value === 'true' || event.target.name === 'assumptionsQuestion[0]') {
      this.setState({
        showAssumptionsError: false,
      });
      dispatch(change('declaration[2]', 'true'));
      this.setAssumption();
    }
  }

  private hasVehicles() {
    const { vehicleCount } = this.props;
    return vehicleCount > 0;
  }

  private validateVehicleCount() {
    const { vehicleCount } = this.props;
    return vehicleCount === 0 || vehicleCount <= 10;
  }

  public render() {
    const {
      handleSubmit,
      auth,
      quote,
      declaration,
      channel,
      insured,
      assumptionsPass,
      renderDefinition,
      renewal,
    } = this.props;
    const isAuth = auth.isAuthenticated;

    const isValid = this.areEmailsSame() && this.validateDeclaration() && this.declarationAgreed() &&
      this.hasVehicles() && this.validateVehicleCount();

    return (
      <div>
        <Form horizontal={true}
              onSubmit={handleSubmit}
              autoComplete="off">
          <div className="steps-container">

            <div className="sub-content-container">
              <div className="welcome-header">Welcome to {channel.baseName}’s Online Agricultural Vehicle Insurance.
              </div>

              <p style={{ fontSize: '15px' }}>
                Thank you for your interest in insuring your agricultural vehicle(s)* through Greenlands Insurance
                Services Limited.
                <br /><br />
                We are proud to have teamed up with leading speciality insurer and reinsurer MSIG Europe to provide you
                with an online ‘quote & buy’ facility for your agricultural vehicle(s). We hope you find it to be quick,
                simple and hassle-free.
                <br /><br />
                Should you require any assistance using this facility then please don’t hesitate to <ContactUsModal
                channel={channel} text="contact us" /> directly
                on {channel.phone}.
                <br /><br />
                *Up to 10 vehicles. For anything above this, please <ContactUsModal
                channel={channel} text="contact us" />.
              </p>
              <FormGroup controlId={'insured.email'}>
                <Col componentClass={ControlLabel} sm={5}>
                  Please enter your email address:
                </Col>
                <Col sm={5}>
                  <Field
                    name={`insured.email`}
                    type="email"
                    component={FieldFormControl}
                    onBlur={this.handleCheckExistingCustomer}
                    disabled={isAuth}
                    validate={[
                      isRequired,
                      isEmail,
                    ]}
                    placeholder="email@domain.com"
                  />
                  {!isUndefined(insured) && insured.email && isEmail(insured.email) && (
                    <div className="has-error">
                      <HelpBlock><FaInfoCircle /><strong>{' '}{isEmail(insured.email)}</strong></HelpBlock>
                    </div>
                  )}
                </Col>
              </FormGroup>
              <FormGroup controlId={'insured.emailConfirm'}>
                <Col componentClass={ControlLabel} sm={5}>
                  Please confirm your email address:
                </Col>
                <Col sm={5}>
                  <Field
                    name={`insured.emailConfirmation`}
                    type="email"
                    onBlur={this.handleChecks}
                    component={FieldFormControl}
                    disabled={isAuth}
                    validate={[
                      isRequired,
                      isEmail,
                    ]}
                    placeholder="Confirm Email"
                  />
                  {this.state.notFocused && !this.areEmailsSame() && (
                    <div className="has-error">
                      <HelpBlock>The email address must match the one previously entered.</HelpBlock>
                    </div>
                  )}
                  {this.state.notFocused
                  && !isUndefined(insured)
                  && insured.emailConfirmation
                  && isEmail(insured.emailConfirmation) && (
                    <div className="has-error">
                      <HelpBlock><FaInfoCircle /><strong>{' '}{isEmail(insured.emailConfirmation)}</strong></HelpBlock>
                    </div>
                  )}
                </Col>
              </FormGroup>
            </div>

            <div className="sub-content-container">
              <Row className="declaration-sub-content-container-alt">
                <Col sm={12} md={9} lg={9}>
                  {renderDefinition('b2c_declarations_bankrupt')}
                  Have you or any drivers been declared bankrupt or insolvent, been the subject of bankruptcy or
                  insolvency proceedings, unless discharged?
                </Col>
                <Col sm={12} md={3} lg={3}>
                  <Row className="declaration-button-group-container pull-right">
                    <Col sm={6} md={6} lg={6} className="button-group-btn-container">
                      <Field
                        name="declarationQuestion[0]"
                        type="radio"
                        value="true"
                        component={FieldFormControl}
                      >
                        <div className={'button-group-btn'}>
                          No
                          <FaCheck/>
                        </div>
                      </Field>
                    </Col>
                    <Col sm={6} md={6} lg={6} className="button-group-btn-container">
                      <Field
                        name="declarationQuestion[0]"
                        type="radio"
                        value="false"
                        component={FieldFormControl}
                      >
                        <div className={'button-group-btn'}>
                          Yes
                          <FaCheck/>
                        </div>
                      </Field>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="declaration-sub-content-container-alt">
                <Col sm={9}>
                  Have you or any drivers had insurance refused, declined, cancelled or had special terms imposed at
                  any time?
                </Col>
                <Col sm={3}>
                  <Row className="declaration-button-group-container pull-right">
                    <Col sm={6} className="button-group-btn-container">
                      <Field
                        name="declarationQuestion[1]"
                        type="radio"
                        value="true"
                        component={FieldFormControl}
                      >
                        <div className={'button-group-btn'}>
                          No
                          <FaCheck/>
                        </div>
                      </Field>
                    </Col>
                    <Col sm={6} className="button-group-btn-container">
                      <Field
                        name="declarationQuestion[1]"
                        type="radio"
                        value="false"
                        component={FieldFormControl}
                      >
                        <div className={'button-group-btn'}>
                          Yes
                          <FaCheck/>
                        </div>
                      </Field>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="declaration-sub-content-container-alt">
                <Col sm={9}>
                  Have you or any drivers had any unspent non-motoring convictions according to the Rehabilitation of
                  Offenders Act, nor have any prosecutions pending?
                </Col>
                <Col sm={3}>
                  <Row className="declaration-button-group-container pull-right">
                    <Col sm={6} className="button-group-btn-container">
                      <Field
                        name="declarationQuestion[2]"
                        type="radio"
                        value="true"
                        component={FieldFormControl}
                      >
                        <div className={'button-group-btn'}>
                          No
                          <FaCheck/>
                        </div>
                      </Field>
                    </Col>
                    <Col sm={6} className="button-group-btn-container">
                      <Field
                        name="declarationQuestion[2]"
                        type="radio"
                        value="false"
                        component={FieldFormControl}
                      >
                        <div className={'button-group-btn'}>
                          Yes
                          <FaCheck/>
                        </div>
                      </Field>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="declaration-sub-content-container-alt">
                <Col sm={9}>
                  Will your vehicle/s be loaned, leased or hired out to another party?
                </Col>
                <Col sm={3}>
                  <Row className="declaration-button-group-container pull-right">
                    <Col sm={6} className="button-group-btn-container">
                      <Field
                        name="declarationQuestion[3]"
                        type="radio"
                        value="true"
                        component={FieldFormControl}
                      >
                        <div className={'button-group-btn'}>
                          No
                          <FaCheck/>
                        </div>
                      </Field>
                    </Col>
                    <Col sm={6} className="button-group-btn-container">
                      <Field
                        name="declarationQuestion[3]"
                        type="radio"
                        value="false"
                        component={FieldFormControl}
                      >
                        <div className={'button-group-btn'}>
                          Yes
                          <FaCheck/>
                        </div>
                      </Field>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="declaration-sub-content-container-alt">
                <Col sm={9}>
                  {renderDefinition('b2c_declarations_motor_trade')}
                  Will your vehicle/s be used for construction, racing, endurance competitions or in connection with the
                  motor trade?
                </Col>
                <Col sm={3}>
                  <Row className="declaration-button-group-container pull-right">
                    <Col sm={6} className="button-group-btn-container">
                      <Field
                        name="declarationQuestion[4]"
                        type="radio"
                        value="true"
                        component={FieldFormControl}
                      >
                        <div className={'button-group-btn'}>
                          No
                          <FaCheck/>
                        </div>
                      </Field>
                    </Col>
                    <Col sm={6} className="button-group-btn-container">
                      <Field
                        name="declarationQuestion[4]"
                        type="radio"
                        value="false"
                        component={FieldFormControl}
                      >
                        <div className={'button-group-btn'}>
                          Yes
                          <FaCheck/>
                        </div>
                      </Field>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {! this.validateDeclaration() && (
                <div className="alert alert-danger">
                  <p>
                    Thank you for your enquiry. Please note that due to your selection(s), we are unable to continue
                    with your quotation online - to enable us to assist you, please <ContactUsModal
                    channel={channel} text="contact us" linkClass="inherit-color" /> to speak with one of our
                    specialist advisors.
                  </p>
                </div>
              )}
            </div>

            {this.declarationAgreed() && (
              <div>
                {this.renderVehicleCounter()}
                {! this.validateVehicleCount() && (
                  <div className="alert alert-danger">
                    <p>
                      Thank you for your enquiry. Please note that due to your selection(s), we are unable to continue
                      with your quotation online - to enable us to assist you, please <ContactUsModal
                      channel={channel} text="contact us" linkClass="inherit-color" /> to speak with one of
                      our specialist advisors.
                    </p>
                  </div>
                )}
              </div>
            )}

            <NavigationBar
              hasBackButton={false}
              {...this.props}
              nextButtonDisabled={! isValid || (!auth.isAuthenticated && !quote.existingCustomer.checked)}
              onClickSubmit={(declaration && declaration[2] === 'true') && !assumptionsPass && !renewal ?
                this.handleSubmit : this.openAssumptionsModal}
            />

            {this.renderAssumptions()}
          </div>
        </Form>
        <Modal show={this.props.quote.existingCustomer.showModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton={true}>
            {this.props.quote.existingCustomer.status === ('active' || 'pending') ? (
              <Modal.Title>Customer Account</Modal.Title>
            ) : (
              <Modal.Title>Important</Modal.Title>
            )}
          </Modal.Header>
          <Modal.Body>
            {this.props.quote.existingCustomer.status === ('active' || 'pending') && (
              <Login showHeader={false} redirectTo={'/'} embed={true}/>
            )}
            {this.props.quote.existingCustomer.status === 'new' && (
              <div className="alert">
                <p className={'red'}>
                  This email address has already been used in a previous quote. <br/>
                  Before continuing, we ask you to activate your account. <br/>
                  You will shortly receive an email that contains all the necessary instructions.
                </p>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </div>
    );
  }

  private handleChecks = () => {
    this.setState({
      notFocused: true,
    });
    this.handleCheckExistingCustomer();
  }

  private handleCheckExistingCustomer = () => {
    const { email, emailConfirmation, actions, auth, quote } = this.props;
    if (email === '' || emailConfirmation === '') {
      return;
    }

    const isAuth = auth.isAuthenticated;
    const emailsDifferent = quote.existingCustomer.email !== '' && email !== quote.existingCustomer.email;
    if (email === emailConfirmation && !isAuth && (!quote.existingCustomer.checked || emailsDifferent)) {
      actions.quote.checkExistingCustomer(email);
    }
  }

  private handleCloseModal = () => {
    const { actions } = this.props;
    actions.quote.closeExistingCustomerModal();
  }

  private handleSubmit = () => {
    const {quote, actions, dispatch} = this.props;

    if (quote.existingCustomer.checked && quote.existingCustomer.hasCustomer) {
      actions.quote.openExistingCustomerModal();
    } else {
      dispatch(submit('quote'));
    }
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const startDate = selector(state, 'startDate');
      const quotationTypes = selector(state, 'quotationTypes');
      const insured = selector(state, 'insured');
      const email = selector(state, 'insured.email');
      const emailConfirmation = selector(state, 'insured.emailConfirmation');
      const declaration = selector(state, 'declaration');
      const vehicleCount = selector(state, 'vehicleCount');
      const declarationQuestion = selector(state, 'declarationQuestion');
      const assumptionsQuestion = selector(state, 'assumptionsQuestion');
      const assumptionsPass = selector(state, 'assumptionsPass');

      return {
        startDate,
        quotationTypes,
        insured,
        email,
        emailConfirmation,
        declaration,
        vehicleCount,
        declarationQuestion,
        assumptionsQuestion,
        assumptionsPass,
        auth: state.auth,
        quote: state.quote,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(DeclarationForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Declaration/index.tsx